<app-autocomplete *ngIf="form"
                  (valueSelected)="changeOrg($event)"
                  (search)="handleOrgSearch($event)"
                  [config]="config"
                  [controlsConfig]="null"
                  [displayTransformFn]="orgTransformFn"
                  [formControl]="contactSenderOrg"
                  [options]="filteredOrgOptions$ | async"
                  [preventInput]="true"
                  [searchEnabled]="true"
                  [searchDebounce]="0"
                  [size]="size"
                  class="form-row"
                  data-test-id="OrganizationAutocomplete">
  <ng-template appAutocompleteOption let-option>
    {{ option?.Description }}
  </ng-template>
</app-autocomplete>
